import {Component, Input, EventEmitter, Output, ViewChild, ElementRef, AfterViewInit, OnInit} from '@angular/core';
import { QRCodeComponent } from 'angularx-qrcode';
import {TypeLoading} from "@app/enums";
import {environment} from "@env/environment";
import { Passenger } from '@app/models/micro/passenger.model';
import { Reservation } from '@app/models/micro/reservation.model';
import { ApiService } from '@app/services/micro/api.service';
import { GlobalsService } from '@app/services/micro/globals.service';
import { SeatsService } from '@app/services/seats.service';
import { TranslateService } from '@ngx-translate/core';
import { SharedModule } from "@shared/shared.module";
import { PassengerService } from "@services/micro/passenger.service";
/**
  Componente que genera el QR de la Reservación
**/
@Component({
    selector: 'app-am-qrcode',
    templateUrl: './am-qrcode.component.html',
    styleUrls: ['./am-qrcode.component.scss'],
    standalone: false
})
export class AmQrcodeComponent implements OnInit {
  url = '';
  reservation: Reservation;
  passengers: Passenger[];
  language: string = '';
  constructor(private _globalService: GlobalsService,
              private _traslateService: TranslateService,) {

  }

  ngOnInit(): void {
    this.initPage();
  }

  initPage() {
    this.reservation = this._globalService.getReservation();
    this.language = this._traslateService.currentLang;
    // https://mad.amlab7.com/myb/es-mx/reembolsos?last-name=Doe&pnr=SHTELE
    this.url = `${environment.urlWeb}myb/es-mx/reembolsos?last-name=${this.reservation.passengers[0].lastName}&pnr=${this.reservation.pnr}&utm_source=kioscos`;
    console.log(this.url);
  }
}
